import type { PaywallRoute } from '@/@types/router-types'

const PaywallView = () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/PaywallView.vue')

type PaywallInstance = {
	name: PaywallRoute
	config: () => Promise<unknown>
}

type PaywallRedirect = {
	name: `plan-email-${string}`
	redirect: { name: PaywallRoute }
}

export const paywallInstances: PaywallInstance[] = [
	{
		name: 'plan-email',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email'),
	},
	{
		name: 'plan-email-assessment',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-assessment'),
	},
	{
		name: 'plan-email-female',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-female'),
	},
	{
		name: 'plan-email-pilates',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-pilates'),
	},
	{
		name: 'plan-email-one-click-purchase',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-one-click-purchase'),
	},
	{
		name: 'plan-email-one-click-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/one-click/email-one-click-m'),
	},
	{
		name: 'plan-email-one-click-female', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/one-click/email-one-click-f'),
	},
	{
		name: 'plan-email-fsa-hsa',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-fsa-hsa'),
	},
	{
		name: 'plan-email-christmas-deal-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-christmas-deal-m'),
	},
	{
		name: 'plan-email-christmas-deal-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-christmas-deal-f'),
	},
	{
		name: 'plan-email-merry-christmas-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-merry-christmas-m'),
	},
	{
		name: 'plan-email-merry-christmas-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-merry-christmas-f'),
	},
	{
		name: 'plan-email-ready-for-new-year-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-ready-for-new-year-m'),
	},
	{
		name: 'plan-email-ready-for-new-year-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-ready-for-new-year-f'),
	},
	{
		name: 'plan-email-new-year-sale-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-new-year-sale-m'),
	},
	{
		name: 'plan-email-new-year-sale-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-new-year-sale-f'),
	},
	{
		name: 'plan-email-new-year-sale-last-day-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-new-year-sale-last-day-m'),
	},
	{
		name: 'plan-email-new-year-sale-last-day-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-new-year-sale-last-day-f'),
	},
	{
		name: 'plan-email-kick-off-new-year-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-kick-off-new-year-m'),
	},
	{
		name: 'plan-email-kick-off-new-year-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-kick-off-new-year-f'),
	},
	{
		name: 'plan-in-app', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/in-app'),
	},
	{
		name: 'plan-main',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/main'),
	},
	{
		name: 'plan-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m'),
	},
	{
		name: 'plan-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m-eu'),
	},
	{
		name: 'plan-m-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m-us'),
	},
	{
		name: 'plan-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f'),
	},
	{
		name: 'plan-f-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/f-us'),
	},
	{
		name: 'plan-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/f-al'),
	},
	{
		name: 'plan-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f-eu'),
	},
	{
		name: 'plan-f-br',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f-br'),
	},
	{
		name: 'plan-activity-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-f'),
	},
	{
		name: 'plan-activity-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-f-eu'),
	},
	{
		name: 'plan-activity-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-m'),
	},
	{
		name: 'plan-activity-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-m-eu'),
	},
	{
		name: 'plan-pilates-f-commitment',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/pilates-f-commitment'),
	},
	{
		name: 'plan-pilates-f-commitment-us',
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/pilates-f-commitment-us'),
	},
	{
		name: 'plan-pilates-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/pilates-f-al'),
	},
	{
		name: 'plan-yoga-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-f'),
	},
	{
		name: 'plan-yoga-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-f-eu'),
	},
	{
		name: 'plan-yoga-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/yoga-f-al'),
	},
	{
		name: 'plan-yoga-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-m'),
	},
	{
		name: 'plan-chair-workouts-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/chair-workouts-m'),
	},
	{
		name: 'plan-yoga-m-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/yoga-m-us'),
	},
	{
		name: 'plan-yoga-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-m-eu'),
	},
	{
		name: 'plan-walking-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-f'),
	},
	{
		name: 'plan-printable-walking-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/printable-walking-f'),
	},
	{
		name: 'plan-walking-f-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-f-us'),
	},
	{
		name: 'plan-walking-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-f-al'),
	},
	{
		name: 'plan-walking-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-f-eu'),
	},
	{
		name: 'plan-tai-chi-walking-f-v2',
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/tai-chi-walking-f-v2'),
	},
	{
		name: 'plan-walking-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-m'),
	},
	{
		name: 'plan-walking-m-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-m-us'),
	},
	{
		name: 'plan-walking-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-m-eu'),
	},
	{
		name: 'plan-tai-chi-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/tai-chi-f'),
	},
	{
		name: 'plan-tai-chi-yoga-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/tai-chi-yoga-m'),
	},
	{
		name: 'plan-calisthenics-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/calisthenics-m'),
	},
	{
		name: 'plan-calisthenics-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/calisthenics-f'),
	},
	{
		name: 'plan-menopause-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/menopause-f'),
	},
	{
		name: 'plan-cortisol-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/cortisol-f'),
	},
	{
		name: 'plan-walking-japanese-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-japanese-f'),
	},
	{
		name: 'plan-glp-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/glp-f'),
	},
]

const paywallRedirects: PaywallRedirect[] = [
	{ name: 'plan-email-activity', redirect: { name: 'plan-activity-f' } },
	{ name: 'plan-email-activity-male', redirect: { name: 'plan-activity-m' } },
	{ name: 'plan-email-pilates-commitment', redirect: { name: 'plan-pilates-f-commitment' } },
	{ name: 'plan-email-yoga', redirect: { name: 'plan-yoga-f' } },
	{ name: 'plan-email-yoga-male', redirect: { name: 'plan-yoga-m' } },
	{ name: 'plan-email-chair-workouts-m', redirect: { name: 'plan-chair-workouts-m' } },
	{ name: 'plan-email-walking', redirect: { name: 'plan-walking-f' } },
	{ name: 'plan-email-walking-male', redirect: { name: 'plan-walking-m' } },
	{ name: 'plan-email-calisthenics-male', redirect: { name: 'plan-calisthenics-m' } },
	{ name: 'plan-email-calisthenics-female', redirect: { name: 'plan-calisthenics-f' } },
	{ name: 'plan-email-menopause-female', redirect: { name: 'plan-menopause-f' } },
	{ name: 'plan-email-cortisol-f', redirect: { name: 'plan-cortisol-f' } },
	{ name: 'plan-email-glp-f', redirect: { name: 'plan-glp-f' } },
	{ name: 'plan-email-walking-japanese', redirect: { name: 'plan-walking-japanese-f' } },
	{ name: 'plan-email-tai-chi-yoga-male', redirect: { name: 'plan-tai-chi-yoga-m' } },
]

const paywallInstanceRoutes = paywallInstances.map((instance) => {
	const id = instance.name.replace('plan-', '')
	return {
		path: `/plan/${id}`,
		name: instance.name,
		component: {
			render: (h) =>
				h(PaywallView, {
					key: id,
					props: {
						id,
						config: instance.config,
					},
				}),
		},
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingCreatedProgramScreen',
				},
			},
		},
	}
})

const paywallRedirectRoutes = paywallRedirects.map((item) => {
	const id = item.name.replace('plan-', '')
	return {
		path: `/plan/${id}`,
		name: item.name,
		redirect: item.redirect,
	}
})

const paywallRoutesList = [...paywallInstanceRoutes, ...paywallRedirectRoutes]

export default paywallRoutesList
